import React, { Fragment } from 'react';

import { Alert, Margin, Spacer } from '@zapier/design-system';
import { Spacing } from '@zapier/theme';

import CtaPublicIntegration from 'app/developer-v3/components/CtaPublicIntegration';
import IntegrationSettingsForm from 'app/developer-v3/components/IntegrationSettingsForm';
import Link from 'app/common/components/Link';
import ManagerLayout from 'app/developer-v3/layouts/ManagerLayout';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { useAvroEvent } from 'app/developer-v3/hooks';

import type { AppFormType as Settings } from 'app/developer-v3/types';

type Props = {
  cancelUrl: string;
  initialSettings: Settings;
  isLoading: boolean;
  isPublished: boolean;
  isSaving: boolean;
  update: (integrationSettings: Settings) => Promise<void>;
};

function SettingsPage({
  cancelUrl,
  initialSettings,
  isLoading,
  isPublished,
  isSaving,
  update,
}: Props) {
  const { correlationIds, emitPartnerUserInteractionEvent } = useAvroEvent();

  return (
    <ManagerLayout title="Integration Settings">
      <Margin margin="0px 0px 30px">
        {isPublished ? (
          <Fragment>
            <CtaPublicIntegration />
            <Spacer height={Spacing.medium} />
          </Fragment>
        ) : null}
        <Alert status="info">
          <Link
            href={`${BASE_DOC_URL_VB}/publish/integration-publishing-requirements#5-7-integration-uses-english-language`}
            target="_blank"
          >
            Use English
          </Link>{' '}
          for all user-facing text.
        </Alert>
      </Margin>
      <IntegrationSettingsForm
        cancelUrl={cancelUrl}
        initialSettings={initialSettings}
        isLoading={isLoading}
        isPublished={isPublished}
        isSaving={isSaving}
        onSubmit={async settings => {
          emitPartnerUserInteractionEvent({
            correlationId:
              correlationIds.update_integration_settings_prompt_clicked,
            eventAction: 'click',
            interactionGoal: 'Saves changes to integration settings',
            interactionName: 'integration_settings_save_clicked',
          });
          return update(settings);
        }}
      />
    </ManagerLayout>
  );
}

export default SettingsPage;
